// extracted by mini-css-extract-plugin
var _1 = "NavArrows-moduleNavArrows__ZbT73";
var _2 = "NavArrows-modulenextAction__GGhhs NavArrowButton-moduleNavArrowButton__PbEBW Button-modulebutton__AisLs Flat-moduleflat__s3eC8";
var _3 = "NavArrows-moduleprevAction__pgjEo NavArrowButton-moduleNavArrowButton__PbEBW Button-modulebutton__AisLs Flat-moduleflat__s3eC8";
export { _1 as "NavArrows", _2 as "nextAction", _3 as "prevAction" }
